import React, { useContext } from "react";
import { trackPath } from "../../../../helpers";
import { Button } from "../../button";
import { SiteContext } from "../../global/site-context";
import PortableText from "../../portableText";
import {
  ATTRIBUTION_PARAM,
  DEMO_PHRASE,
  DEMO_URL,
} from "./navigation";
import { cn } from "../../../lib/helpers";

export const DEMO_PAGES = [
  "/demo/",
  "/demo-brand/",
  "/contact/",
  "/hello/databricks-bm9kZWpz/",
  "/hello/deel-ZGF0YWJ/",
  "/hello/grafana-5eh8xp3/",
  "/hello/stripe-4twr3iz9o/",
  "/start/",
];

export const GetStarted = ({ section, summary }) => {
  const site = useContext(SiteContext);
  const path = trackPath(site?.doc);

  return (
    <div className={cn(
      "px-4 lg:px-0 py-8 flex items-center gap-6 lg:gap-10",
      section?.layout === "centered" ? "flex-col text-center justify-center" : null
    )}>
      <div>
        {summary ? (
          <h4 className="text-2xl md:text-4xl font-semibold tracking-tight">{summary}</h4>
        ) : section?._rawSummary ? (
          <PortableText blocks={section._rawSummary} className="text-xl" />
        ) : (
          <h4 className="text-2xl md:text-4xl font-semibold tracking-tight">
            {site.token("getStartedSummary")}
          </h4>
        )}
      </div>
      <div>
        <Button
          text={DEMO_PHRASE}
          href={`${DEMO_URL}?${ATTRIBUTION_PARAM}=get-started-banner--${path}`}
          bgColor="bg-black"
          className="mr-3"
          isBig={true}
        />
      </div>
    </div>
  );
};
